import auth from '../../../config/app-specific-config/auth';
import * as types from './external-integration-actions-types';
import { axiosInstance } from '../../../config/app-specific-config/axiosConfig';
import { redirectToNewPage, validateUrlFormat } from '../../global/helpers/global-helpers';


export const setExternalIntegrationsConfig = (p) => {
	return {
		type: types.SET_EXTERNAL_INTEGRATIONS_CONFIG,
		payload: p
	};
}

// REVOKING
export const revokeOauthSuccess = (response) => {
	return {
		type: types.GENERAL_REVOKE_OAUTH_SUCCESS,
		payload: response.data
	};
};

export const revokeOauthFailure = (error) => {
	return {
		type: types.GENERAL_REVOKE_OAUTH_FAILURE,
		error
	};
};

export const revokeOauthRequest = () => {
	return {
		type: types.GENERAL_REVOKE_OAUTH_REQUEST
	};
};

export function revokeOauth(revokeOauthMetadata) {

	return async (dispatch) => {
		dispatch(revokeOauthRequest());
		try {
			const url = `/integrations/general/oauth/revoke`;
			const headers = await auth.getAccessToken();
			const response = await axiosInstance.post(
				url,
				{	revokeOauthMetadata },
				{ headers }
			);
			
			if (response.data.data.revokedSuccessfully === true) {
				if (response.data.data.authorisedExternalIntegrations) {
					dispatch(setExternalIntegrationsConfig(response.data.data.authorisedExternalIntegrations))
				}
			}
		
			dispatch(revokeOauthSuccess(response));
		} catch (error) {
			dispatch(revokeOauthFailure(error));
		}
	};
}


// GET method
export const getZoomOauthRedirectUriSuccess = (response) => {
	return {
		type: types.ORG_ZOOM_OAUTH_SUCCESS,
		payload: response.data
	};
};

export const getZoomOauthRedirectUriFailure = (error) => {
	return {
		type: types.ORG_ZOOM_OAUTH_FAILURE,
		error
	};
};

export const getZoomOauthRedirectUriRequest = () => {
	return {
		type: types.ORG_ZOOM_OAUTH_REQUEST
	};
};

export function getZoomOauthRedirectUri() {

	return async (dispatch) => {
		dispatch(getZoomOauthRedirectUriRequest());
		try {
			const url = `/integrations/zoom/oauth/authorise`;
			const headers = await auth.getAccessToken();
			const response = await axiosInstance.get(url, {
				headers
			});
		
			if (response.data.data.authorizationUrl) {
				// const authorizationUrl = response.data.authorizationUrl;
				const validatedUrl = validateUrlFormat(response.data.data.authorizationUrl)

				// Redirect the user to Zoom's OAuth authorization page
				if (!!validatedUrl) {
					window.location.href = response.data.data.authorizationUrl;
				} else {
					console.log('Invalid URL')
				}
			}
			dispatch(getZoomOauthRedirectUriSuccess(response));
		} catch (error) {
			dispatch(getZoomOauthRedirectUriFailure(error));
		}
	};
}


// Get Zoom Oauth tokens
export const getZoomOauthTokensSuccess = (response) => {
	return {
		type: types.ORG_ZOOM_OAUTH_SUCCESS,
		payload: response.data
	};
};

export const getZoomOauthTokensFailure = (error) => {
	return {
		type: types.ORG_ZOOM_OAUTH_FAILURE,
		error
	};
};

export const getZoomOauthTokensRequest = () => {
	return {
		type: types.ORG_ZOOM_OAUTH_REQUEST
	};
};

export function getZoomOauthTokens(requestZoomTokenMetadata) {
	return async (dispatch) => {
		dispatch(getZoomOauthTokensRequest());
		try {
			const url = `/integrations/zoom/oauth/tokens`;
			const headers = await auth.getAccessToken();
			const response = await axiosInstance.post(
				url,
				{	requestZoomTokenMetadata },
				{ headers }
			);
		
	
			if (response.data.data.tokens) {
				const {accessToken} = response.data.data.tokens || {};
	
				if (accessToken)	{
					const redirectRoute = (requestZoomTokenMetadata.isCreatedUser === true) ? `/home?state=zoom-welcome` : `/profile?section=3`;
					redirectToNewPage(redirectRoute)
				}
			} 
		
			dispatch(getZoomOauthTokensSuccess(response));
		} catch (error) {
			dispatch(getZoomOauthTokensFailure(error));
		}
	};
}